"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTable = void 0;
var tslib_1 = require("tslib");
var get_1 = (0, tslib_1.__importDefault)(require("lodash/get"));
var isFunction_1 = (0, tslib_1.__importDefault)(require("lodash/isFunction"));
var partition_1 = (0, tslib_1.__importDefault)(require("lodash/partition"));
var sortBy_1 = (0, tslib_1.__importDefault)(require("lodash/sortBy"));
var react_1 = require("react");
function isSortControlled(sort) {
    return typeof sort !== 'undefined';
}
function useTable(options) {
    var data = options.data, columns = options.columns, limit = options.limit, initialSort = options.initialSort, _a = options.initialSortDirection, initialSortDirection = _a === void 0 ? 'ascending' : _a, _b = options.offset, offset = _b === void 0 ? 0 : _b, _c = options.onSort, onSort = _c === void 0 ? function () { return undefined; } : _c, sort = options.sort;
    var _d = (0, react_1.useState)(initialSort), currentSort = _d[0], setCurrentSort = _d[1];
    var _e = (0, react_1.useState)(null), sortBy = _e[0], setSortBy = _e[1];
    var _f = (0, react_1.useState)(initialSortDirection === 'ascending'), isAscending = _f[0], setAscending = _f[1];
    var _g = (0, react_1.useState)(null), changedColumnName = _g[0], setChangedColumnName = _g[1];
    function handleSort(columnName, sortBy) {
        if (isSortControlled(sort)) {
            onSort(sort.direction === 'ascending' ? 'descending' : 'ascending', columnName);
            return;
        }
        setChangedColumnName(columnName);
        setSortBy(function () { return sortBy; });
        if (currentSort === columnName) {
            setAscending(function (prevIsAscending) { return !prevIsAscending; });
            return;
        }
        setAscending(true);
        setCurrentSort(columnName);
    }
    var rowsSortByValues = (0, react_1.useMemo)(function () { return columns.map(function (c) { return ({ dataField: c.dataField, sortBy: c.sortBy }); }); }, [columns]);
    var rows = (0, react_1.useMemo)(function () {
        if (isSortControlled(sort)) {
            return data;
        }
        var rowSortBy = rowsSortByValues.find(function (_a) {
            var dataField = _a.dataField;
            return dataField === currentSort;
        });
        var sortedRows = (0, sortBy_1.default)(data, sortingFn((rowSortBy === null || rowSortBy === void 0 ? void 0 : rowSortBy.sortBy) || sortBy, currentSort));
        if (!isAscending) {
            sortedRows = sortedRows.reverse();
        }
        else {
            var _a = (0, partition_1.default)(sortedRows, sortingFn((rowSortBy === null || rowSortBy === void 0 ? void 0 : rowSortBy.sortBy) || sortBy, currentSort)), definedRows = _a[0], undefinedRows = _a[1];
            sortedRows = (0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], definedRows, true), undefinedRows, true);
        }
        var endIndex = limit ? limit + offset : sortedRows.length;
        return sortedRows.slice(offset, endIndex);
    }, [currentSort, data, isAscending, limit, offset, rowsSortByValues, sort, sortBy]);
    (0, react_1.useEffect)(function () {
        if (!changedColumnName)
            return;
        onSort(getDirection(isAscending), changedColumnName);
    }, [changedColumnName, isAscending, onSort]);
    return {
        sort: handleSort,
        rows: rows,
        direction: isSortControlled(sort) ? sort.direction : getDirection(isAscending),
        currentSort: isSortControlled(sort) ? sort.field : currentSort,
    };
}
exports.useTable = useTable;
function sortingFn(sortBy, currentSort) {
    if (!sortBy) {
        return function (row) {
            var value = (0, get_1.default)(row, currentSort || '') || '';
            if (typeof value === 'number')
                return value;
            return String(value).toLowerCase();
        };
    }
    if ((0, isFunction_1.default)(sortBy)) {
        return function (row) {
            return sortBy(row);
        };
    }
    return function (row) {
        var composedString = sortBy.map(function (key) { return (0, get_1.default)(row, key); }).join('');
        if (!Number.isNaN(Number(composedString)))
            return Number(composedString);
        return composedString;
    };
}
function getDirection(isAscending) {
    return isAscending ? 'ascending' : 'descending';
}
//# sourceMappingURL=hooks.js.map